import {
  AfterViewInit, Component, EventEmitter,
  Input, OnInit, Output,
  QueryList, ViewChildren
} from '@angular/core';
import DevExpress from 'devextreme';
import { DxDataGridComponent } from 'devextreme-angular';
import dxDataGrid from 'devextreme/ui/data_grid';

import { BehaviorSubject } from 'rxjs';
import {
  IEidosMatrixApi, IMatrixCellStatus, EidosMatrixValue,
  IEidosMatrixColumn, IMatrixConfig, IEidosMatrixRequestAction,
  IEidosMatrixRequestNewItem, IMatrixRif, IEidosMatrixValue,
  IMatrixValueChanged, MatrixColumn, EidosMatrixConfig,
  EidosMatrixData, MatrixFormulaRangeType, EidosMatrixSheet, IEidosMatrixValueFun, IEidosMatrixGenericFun
} from './eidos-matrix.model';
import { LbaActionMenuItem } from '@app/standalones/ui/components/lba-action-menu/lba-action-menu.component';


//regular expression per splittare una formula estraendo i riferimenti
const rCellRif = new RegExp(/[\+,\-,\*\/,\(,\),\[,\],\{,\},\;,\,,\:,\>,\<,\=,\!,\ \",\']/ig);
//regular expression per matchare un riferimento sheet
const rSheetRif = new RegExp(/@s(_\d\.|_\d|\d)+/ig);
const rSheetAllRif = new RegExp(/@s#(@r(<|>|#|_\d\.|_\d|\d))*(@c(<|>|#|_\d\.|_\d|\d))*/ig);
const rSheetBeforeRif = new RegExp(/@s<(@r(<|>|#|_\d\.|_\d|\d))*(@c(<|>|#|_\d\.|_\d|\d))*/ig);
const rSheetAfterRif = new RegExp(/@s>(@r(<|>|#|_\d\.|_\d|\d))*(@c(<|>|#|_\d\.|_\d|\d))*/ig);
//regular expression per matchare un riferimento riga
const rRowRif = new RegExp(/@r(_\d\.|_\d|\d)+/ig);
const rRowAllRif = new RegExp(/(@s(<|>|#|_\d\.|_\d|\d))*@r#(@c(<|>|#|_\d\.|_\d|\d))*/ig);
const rRowBeforeRif = new RegExp(/(@s(<|>|#|_\d\.|_\d|\d))*@r<(@c(<|>|#|_\d\.|_\d|\d))*/ig);
const rRowAfterRif = new RegExp(/(@s(<|>|#|_\d\.|_\d|\d))*@r>(@c(<|>|#|_\d\.|_\d|\d))*/ig);
//regular expression per matchare un riferimento colonna
const rColRif = new RegExp(/@c(_\d\.|_\d|\d)+/ig);
const rColAllRif = new RegExp(/(@s(<|>|#|_\d\.|_\d|\d))*(@r(<|>|#|_\d\.|_\d|\d))*@c#/ig);
const rColBeforeRif = new RegExp(/(@s(<|>|#|_\d\.|_\d|\d))*(@r(<|>|#|_\d\.|_\d|\d))*@c</ig);
const rColAfterRif = new RegExp(/(@s(<|>|#|_\d\.|_\d|\d))*(@r(<|>|#|_\d\.|_\d|\d))*@c>/ig);
const rColNameRif = new RegExp(/@@(\w.+)/ig);
//regular expression per matchare un riferimento a parametro globale
const rParamRif = new RegExp(/@#(\w+)/ig);
@Component({
    selector: 'eidos-matrix',
    templateUrl: './eidos-matrix.component.html',
    styleUrls: ['./eidos-matrix.component.scss'],
    standalone: false
})
export class EidosMatrixComponent implements OnInit, AfterViewInit {
  @ViewChildren(DxDataGridComponent)
  matrixSheetComponents?: QueryList<DxDataGridComponent>;

  // temporary property: only for test at design time
  _test = false;
  public get test(): boolean {
    return this._test;
  }
  @Input()
  public set test(value: boolean) {
    this._test = value;
    if (this.initilized) this.initializeComponent();
  }

  @Input()
  public layout = 'tab';
  @Input()
  public config: BehaviorSubject<IMatrixConfig> = new BehaviorSubject<IMatrixConfig>(EidosMatrixConfig.EmptyConfig);

  @Input()
  public matrixData: EidosMatrixData;
  @Input()
  public isUpdateCellAllowed: boolean = true;

  @Output()
  public requestNewRow: EventEmitter<IEidosMatrixRequestNewItem> = new EventEmitter<IEidosMatrixRequestNewItem>();
  @Output()
  public requestNewColumn: EventEmitter<IEidosMatrixRequestNewItem> = new EventEmitter<IEidosMatrixRequestNewItem>();
  @Output()
  public requestExecAction: EventEmitter<IEidosMatrixRequestAction> = new EventEmitter<IEidosMatrixRequestAction>();

  public activeConfig: EidosMatrixConfig;
  public activeParameters: IEidosMatrixValue;
  public activeFunction: IEidosMatrixGenericFun;
  public activeOnChangeParameters: IEidosMatrixValueFun;
  public parametersDependencies:Set<IMatrixRif>;
  public activeData: EidosMatrixData;
  public activeSheet: number;

  private initilized = false;
  public api: IEidosMatrixApi;
  private masterDetailOpened:Array<string|Array<string>>=[];

  constructor() {
    this.matrixData = [];
    this.activeData = [];
    this.activeConfig = new EidosMatrixConfig(EidosMatrixConfig.EmptyConfig);
    this.activeSheet = 0;
    this.activeParameters = {};
    this.activeOnChangeParameters = {};
    this.activeFunction = {};
    this.parametersDependencies = new Set<IMatrixRif>();

    //bind api matrix methods
    this.api = {
      setValue: this.setValue.bind(this),
      onCellChanges: this.onCellChanges.bind(this),
      getRowIndex: this.getRowIndex.bind(this),
      execAction: this.requestAnAction.bind(this),
      addRow: this.addNewRow.bind(this),
      addColumn: this.addNewColumn.bind(this),
      getMatrixCellValue: this.getMatrixCellValue.bind(this),
      expandSheetAllRif: this.expandSheetAllRif.bind(this),
      expandRowAllRif: this.expandRowAllRif.bind(this),
      expandColAllRif: this.expandColAllRif.bind(this),
      expandRangeRif: this.expandRangeRif.bind(this),
      evaluateRif: this.evaluateRif.bind(this),
      resolveFormula: this.resolveFormula.bind(this),
      evaluateFormula: this.evaluateFormula.bind(this),
      evaluateFormulaRif: this.evaluateFormulaRif.bind(this),
      checkManualTouched: this.checkManualTouched.bind(this),
      setManualTouched: this.setManualTouched.bind(this),
      getFormulaRif: this.getFormulaRif.bind(this),
      resetDependencies: this.resetDependencies.bind(this),
      evaluateDependecies: this.evaluateDependecies.bind(this),
      evaluateCells: this.evaluateCells.bind(this),
      refresh: this.refresh.bind(this),
      repaint: this.repaint.bind(this),
      setColumnVisibilityByOwnerStatus: this.setColumnVisibilityByOwnerStatus.bind(this),
      activeConfig: this.activeConfig,
      activeData: this.activeData,
    }

    this.config.subscribe(c => {
      if(c.formulaParameters) c.formulaParameters.subscribe(fp=>{
        this.activeParameters = fp;
      });
      this.activeOnChangeParameters = c.onChangeParametersFun ?? {};
      this.activeFunction = c.formulaFunctions ?? {};

      this.activeConfig = new EidosMatrixConfig(c);
    });
  }
  public collapse(_: any, column: any, sheet: EidosMatrixSheet, api: IEidosMatrixApi, collapse: boolean): void {
    api.setColumnVisibilityByOwnerStatus(sheet.position, column.index, !collapse);
    sheet.collapsed[column.index] = collapse;
  }
  /**
   * add new row in sheet.
   *
   * position is optional position index (index start from 1).
   *  - if it's undefined the row is add at last position
   *  - if position i negative number the count start from end of matrix rows
   *
   * @param {EidosMatrixSheet} sheet
   * @param {IEidosMatrixValue} newRow
   * @param {number} [position]
   * @memberof EidosMatrixComponent
   */
  addNewRow(sheet: EidosMatrixSheet, newRow: IEidosMatrixValue, position?: number): void {
    sheet.onExecutingTask = true;

    let idx = this.activeData[sheet.position].length; //last element
    if (position !== undefined) {
      if (position < 0) idx = this.activeData[sheet.position].length + position;
      else idx = position - 1;

      //check
      if (idx < 0 || idx > this.activeData[sheet.position].length) idx = this.activeData[sheet.position].length;
    }
    this.activeData[sheet.position].splice(idx, 0, sheet.initializeDataRow(newRow, idx));
    sheet.rows = this.activeData[sheet.position].length;

    this.evaluateCells();

    sheet.onExecutingTask = false;
  };
  /**
   * add new column in sheet.
   *
   * if the definition of new column had any formulas then matrix have to revalutate all sheets
   *
   * position is optional position index (index start from 1).
   *  - if it's undefined the column is add at last position
   *  - if position i negative number the count start from end of matrix rows
   *
   *
   *
   * @param {EidosMatrixSheet} sheet
   * @param {IEidosMatrixColumn} newColumn
   * @param {number} [position]
   * @memberof EidosMatrixComponent
   */
  addNewColumn(sheet: EidosMatrixSheet, newColumn: IEidosMatrixColumn): void {
    sheet.onExecutingTask = true;
    //TODO
    //..


    if (newColumn.formulas !== undefined && newColumn.formulas.length > 0) {
      this.resetDependencies();
      this.evaluateDependecies();
      this.evaluateCells();
    }
    sheet.onExecutingTask = false;
  };
  requestAnAction(_: string, sheet: EidosMatrixSheet): void {
    sheet.onExecutingTask = true;

    //TODO

    sheet.onExecutingTask = false;
  };
  refresh() {
    if (this.matrixSheetComponents) this.matrixSheetComponents.forEach(g => g.instance.refresh());
  }
  repaint() {
    if (this.matrixSheetComponents) this.matrixSheetComponents.forEach(g => g.instance.repaint());
  }
  isManualTouchedStatus(cellInfo: any): boolean {
    if (cellInfo && cellInfo.column && cellInfo.data && cellInfo.column.name) {
      return cellInfo.data['__' + cellInfo.column.name].isManualTouched;
    }
    return false;
  }
  showUndoManualValue(cellInfo: any): boolean {
    if(!this.isManualTouchedStatus(cellInfo)) return false;

    if (cellInfo && cellInfo.column && cellInfo.data && cellInfo.column.name) {
      return cellInfo.data['__' + cellInfo.column.name].hasFormula;
    }
    return false;
  }
  initChildRow(): void {
    document.querySelectorAll(`[data-eidos-child]`).forEach(e=>{
      const childVisibility = !!this.masterDetailOpened.find(k=>k===e.getAttribute('data-eidos-child'));
      if(!childVisibility) (e as HTMLElement).style.display = 'none';
    });
  }
  toogleChildRow(event:Event, cellInfo: any, sheet: EidosMatrixSheet, _matrix: IEidosMatrixApi): void {
    if (!cellInfo) return;
    let element = (event.target || event.currentTarget) as HTMLElement;
    var cl = element.classList;
    const closed=sheet.customizeCommandColumn.closeDetailsIcon;
    const opened=sheet.customizeCommandColumn.openDetailsIcon;

    const open = cl.contains(closed);
    if(open) {
      element.classList.remove(closed);
      element.classList.add(opened);
      this.masterDetailOpened.push(cellInfo.key);
    } else {
      element.classList.remove(opened);
      element.classList.add(closed);
      this.masterDetailOpened = this.masterDetailOpened.filter(k=>k!==cellInfo.key);
    }
    document.querySelectorAll(`[data-eidos-child="${cellInfo.key}"]`).forEach(e=>{
      if(open) (e as HTMLElement).style.removeProperty('display');
      else (e as HTMLElement).style.display = 'none';
    });
  }
  resetStatus(cellInfo: any, sheet: EidosMatrixSheet, matrix: IEidosMatrixApi): void {
    if (!cellInfo) return;
    if (cellInfo.column && cellInfo.data && cellInfo.column.name) {
      cellInfo.data['__' + cellInfo.column.name].isManualTouched = false;
      matrix.evaluateFormula(sheet.columns[sheet.getColumnIndexByName(cellInfo.column.name)], sheet.position, cellInfo.data.__rowIndex);
    }
  }
  displayCustomFormattedValue(cellInfo:any,sheet: EidosMatrixSheet): string | null {
    if (!cellInfo) return null;
    if (cellInfo.column && cellInfo.column.name) {
      var c = sheet.columns.find(c=>c.name === cellInfo.column.name);
      if(!c) return null;
      return c.displayCustomFormattedValue.bind(this)(sheet,cellInfo.column.name,cellInfo.value);
    }
    return null;
  }
  getCallbackButtonText(btn: any, info: any, sheet: EidosMatrixSheet): string {
    if (!btn) {
      return '';
    }
    const text = btn.text;
    if (typeof text === 'function') {
      try {
        return text(info, sheet);
      } catch {
        return '';
      }
    }
    return text ?? '';
  }
  getCallbackButtonTitle(btn: any, info: any, sheet: EidosMatrixSheet): string {
    if (!btn) {
      return '';
    }
    const title = btn.title;
    if (typeof title === 'function') {
      try {
        return title(info, sheet);
      } catch {
        return '';
      }
    }
    return title ?? '';
  }
  getCallbackButtonClass(btn: any, info: any, sheet: EidosMatrixSheet): string | object | undefined {
    if (!btn) {
      return undefined;
    }

    const buttonClass = btn.buttonClass;
    if (typeof buttonClass === 'function') {
      try {
        return buttonClass(info, sheet);
      } catch {
        return undefined;
      }
    }

    return buttonClass;
  }

  private getActionMenuButtonIds(cellInfo: any, sheet: EidosMatrixSheet): string[] {
    const colName = cellInfo?.column?.dataField ?? cellInfo?.column?.name;
    const col = sheet.columns.find(c => c.name === colName);
    return col?.buttonIDs ?? [];
  }

  getActionMenuItems(cellInfo: any, sheet: EidosMatrixSheet): LbaActionMenuItem[] {
    const buttonIds = this.getActionMenuButtonIds(cellInfo, sheet);
    if (!buttonIds.length || !sheet.callbackButtons?.length) {
      return [];
    }

    return buttonIds
      .map(id => sheet.callbackButtons.find(cb => cb.id === id))
      .filter((btn): btn is NonNullable<typeof btn> => !!btn && btn.visible(cellInfo, sheet))
      .map(btn => ({
        id: btn.id,
        text: this.getCallbackButtonText(btn, cellInfo, sheet),
        disabled: !!btn.disabled(cellInfo, sheet),
      }));
  }

  hasVisibleActionMenuItems(cellInfo: any, sheet: EidosMatrixSheet): boolean {
    return this.getActionMenuItems(cellInfo, sheet).length > 0;
  }

  onActionMenuSelect(
    item: LbaActionMenuItem,
    cellInfo: any,
    sheet: EidosMatrixSheet,
    api: IEidosMatrixApi
  ): void {
    const btn = sheet.callbackButtons?.find(cb => cb.id === item.id);
    if (!btn || btn.disabled(cellInfo, sheet)) {
      return;
    }
    btn.callback(cellInfo, sheet, api);
  }
  setValue(rif: IMatrixRif, value: EidosMatrixValue): EidosMatrixValue {
    const c = this.activeConfig.sheets[rif.sheet].columns[rif.column];
    c.touch = true;
    const oldValue = this.activeData[rif.sheet][rif.row][c.name];
    this.activeData[rif.sheet][rif.row][c.name] = value;
    return oldValue;
  }
  focusIn(event:any) {
    event?.element.querySelector('input.dx-texteditor-input')?.select?.();
  }
  onCellChanges(e: Array<DevExpress.ui.dxDataGrid.DataChange>, sheet: EidosMatrixSheet, matrix: IEidosMatrixApi) {
    e.forEach(x => {
      const rowIdx = this.getRowIndex(sheet, x.key);
      if (rowIdx === null) return;
      const rif = { sheet: sheet.position, row: rowIdx } as IMatrixRif
      Object.keys(x.data).forEach(colName => {
        rif.columnName = colName;
        sheet.columns.filter(col => col.name === colName).forEach(col => {
          rif.column = col.position;
          const oldValue = this.setValue(rif, x.data[colName]);
          const event = {
            rif: rif,
            column: col,
            newValue: x.data[colName] as EidosMatrixValue,
            oldValue: oldValue
          } as IMatrixValueChanged;
          if (col.onChange) col.onChange(event, sheet, matrix);

          //set manual touched
          const status = this.activeData[rif.sheet][rif.row][`__${colName}`] as IMatrixCellStatus;
          status.isManualTouched = true;
          status.isTouched = true;

          const dep: Set<IMatrixRif> = new Set();
          col.dependencies.forEach(r =>
            this.evaluateFormula(this.activeConfig.sheets[r.sheet].columns[r.column], r.sheet, r.row).forEach(d => { if (d.sheet === r.sheet && d.row === r.row) dep.add(d); })
          );
          //revaluate formula for dependencies
          dep.forEach(d => this.evaluateFormula(this.activeConfig.sheets[d.sheet].columns[d.column], d.sheet, d.row));
          if(this.activeConfig.callback.onAfterDataChange) this.activeConfig.callback.onAfterDataChange(event);
        });
      });
    });
    //if(e.length>0) this.evaluateCells();
  }
  getRowIndex(sheet: EidosMatrixSheet, key: any): number | null {
    let idx = null;
    this.activeData[sheet.position].forEach((r, i) => { if (r[sheet.rowKey] === key) idx = i; });
    return idx;
  }
  getMatrixCellValue(rif: IMatrixRif): EidosMatrixValue {
    if (rif.sheet < 0) return '';
    if (rif.row < 0) return '';
    if (rif.column < 0) return '';

    return this.activeData[rif.sheet][rif.row][rif.columnName];
  }
  setColumnVisibilityByOwnerStatus(sheet: number, owner: number, visibile: boolean): void {
    if (sheet < 0 || sheet >= this.activeConfig.sheets.length) return;

    this.activeConfig
      .sheets[sheet]
      .columns
      .filter(c => (c as any).ownerBand === owner)
      .forEach((c, idx) => {
        if (idx > 0) {
          try {
            const columnIsVisible = visibile && ((typeof c.isVisible === 'function') ? c.isVisible(c, this.activeConfig.sheets[sheet], this.activeData) : c.isVisible);
            this.columnOptionValue(sheet, c.name, 'visible', columnIsVisible);
          }
          catch {
          }
        }
      });
  }
  /**
   * evaluate formulas in all sheets.
   * The evaluation is performed with 1 deep level
   *
   * @memberof EidosMatrixComponent
   */
  evaluateCells() {
    const dep: Set<IMatrixRif> = new Set();
    this.activeConfig.sheets.forEach(sheet => {
      sheet.columns.forEach(column => {
        if (column.hasFormula()) {
          for (let row = 0; row < sheet.rows; row++) {
            this.evaluateFormula(column, sheet.position, row).forEach(d => dep.add(d))
          }
        }
      });
    });
    //revaluate formula for dependencies
    dep.forEach(d => this.evaluateFormula(this.activeConfig.sheets[d.sheet].columns[d.column], d.sheet, d.row));
    //recompute columns visibility

    this.activeConfig.sheets.forEach(s => {
      s.columns.forEach(c => {
        if ((typeof c.isVisible === 'function')) {
          this.columnOptionValue(s.position, c.name, 'visible', c.isVisible(c, s, this.activeData));
        }
      })
    });
  }

  expandSheetAllRif(exp: string, rangeType: MatrixFormulaRangeType, start: number, end: number): string {
    let expanded = '';
    for (let i = start; i <= end; i++) {
      expanded += ' + ' + exp.replace(`@s${rangeType}`, `@s${i}`);
    }
    return '( ' + expanded + ' )';
  }
  expandRowAllRif(exp: string, rangeType: MatrixFormulaRangeType, start: number, end: number): string {
    let expanded = '';
    for (let i = start; i <= end; i++) {
      expanded += ' + ' + exp.replace(`@r${rangeType}`, `@r${i}`);
    }
    return '( ' + expanded + ' )';
  }
  expandColAllRif(exp: string, rangeType: MatrixFormulaRangeType, start: number, end: number): string {
    let expanded = '';
    for (let i = start; i <= end; i++) {
      expanded += ' + ' + exp.replace(`@c${rangeType}`, `@c${i}`);
    }
    return '( ' + expanded + ' )';
  }
  expandRangeRif(exp: string, current: IMatrixRif, rangeType: MatrixFormulaRangeType): string {
    let nexp = exp;

    let rSheet, rRow, rCol, se = 0, re = 0, ce = 0;
    switch (rangeType) {
      case MatrixFormulaRangeType.All:
        rSheet = rSheetAllRif;
        rRow = rRowAllRif;
        rCol = rColAllRif;

        se = this.activeData.length;
        re = this.activeData[current.sheet].length;
        ce = this.activeConfig.sheets[current.sheet].columns.length;

        break;
      case MatrixFormulaRangeType.Before:
        rSheet = rSheetBeforeRif;
        rRow = rRowBeforeRif;
        rCol = rColBeforeRif;

        se = current.sheet;
        re = current.row;
        ce = current.column;
        break;
      case MatrixFormulaRangeType.After:
        rSheet = rSheetAfterRif;
        rRow = rRowAfterRif;
        rCol = rColAfterRif;

        se = this.activeData.length;
        re = this.activeData[current.sheet].length;
        ce = this.activeConfig.sheets[current.sheet].columns.length;
        break;
      default:
        return nexp;
    }

    let all = nexp.match(rSheet);
    if (all) {
      all.forEach(item => {
        if (item) nexp = nexp.replace(item, this.expandSheetAllRif(item, rangeType, 1, se));
      });
    }
    all = nexp.match(rRow);
    if (all) {
      all.forEach(item => {
        if (item) nexp = nexp.replace(item, this.expandRowAllRif(item, rangeType, 1, re));
      });
    }
    all = nexp.match(rCol);
    if (all) {
      all.forEach(item => {
        if (item) nexp = nexp.replace(item, this.expandColAllRif(item, rangeType, 1, ce));
      });
    }
    //remove current
    var s = current.sheet + 1, r = current.row + 1, c = current.column + 1, cn = current.columnName;
    return nexp.replace(`@s${s}@r${r}@c${c}`, '').replace(`@s${s}@r${r}@@${cn}`, '')
      .replace(`@r${r}@c${c}`, '').replace(`@r${r}@@${cn}`, '')
      .replace(`@s${s}@c${c}`, '').replace(`@s${s}@@${cn}`, '')
      .replace(`@s${s}@r${r}`, '')
      .replace(`@r${r}`, '')
      .replace(`@s${s}`, '')
      .replace(`@c${c}`, '').replace(`@@${cn}`, '')
      .replace('+  )', ')')
      .replace('+  +', '+');
  }
  evaluateRif(rif: string, current: IMatrixRif): IMatrixRif {
    const resolved = { sheet: current.sheet, row: current.row, column: current.column, columnName: current.columnName };
    if (rif.trim() === '') return resolved;

    const r = rif.match(rRowRif);
    const c = rif.match(rColRif);
    const cn = rif.match(rColNameRif);
    if (!r && !c && !cn) return resolved;

    const s = rif.match(rSheetRif);
    if (s) {
      const ms = this.activeData.length;
      const sheet = +s[0].replace('@s', '').replace('_', '-').replace('\.', '');
      if (sheet < 0) resolved.sheet = (s[0].includes('.') ? current.sheet : ms) + sheet;  //trasform to array index 0 based from end
      else resolved.sheet = sheet - 1;  //trasform to array index 0 based
    }

    if (r) {
      const mr = this.activeData[current.sheet].length;
      const row = +r[0].replace('@r', '').replace('_', '-').replace('\.', '');
      if (row < 0) resolved.row = (r[0].includes('.') ? current.row : mr) + row; //trasform to array index 0 based
      else resolved.row = row - 1; //trasform to array index 0 based
    }

    if (c) {
      const col = +c[0].replace('@c', '').replace('_', '-').replace('\.', '');

      const mc = this.activeConfig.sheets[current.sheet].columns.length;
      if (col < 0) resolved.column = (c[0].includes('.') ? current.column : mc) + col; //trasform to array index 0 based
      else if (col > 0 && col <= this.activeConfig.sheets[resolved.sheet].columns.length) resolved.column = col - 1; //trasform to array index 0 based
    }
    if (cn) {
      const colName = cn[0].replace('@@', '').toLowerCase();

      this.activeConfig.sheets[resolved.sheet].columns.forEach((c, i) => {
        if (c.name.toLowerCase() === colName) resolved.column = i;
      });
    }

    //check
    if (resolved.sheet < 0 || resolved.sheet >= this.activeData.length) resolved.sheet = current.sheet - 1;
    if (resolved.row < 0 || resolved.row >= this.activeData[resolved.sheet].length) resolved.row = current.row - 1;
    if (resolved.column < 0 || resolved.column >= this.activeConfig.sheets[resolved.sheet].columns.length) resolved.column = current.column - 1;

    resolved.columnName = this.activeConfig.sheets[resolved.sheet].columns[resolved.column].name;
    return resolved;
  }

  resolveFormula(formula: string, cur: IMatrixRif, skipCondition?:string): any {
    const self = this;

    let rifCell = formula.replace(/@s-/g, '@s_')
      .replace(/@r-/g, '@r_')
      .replace(/@c-/g, '@c_')
      .split(rCellRif)
      .filter(s => s.includes('@'));
    let exp = formula;

    //substitute global parameters
    let parameters = exp.match(rParamRif);
    if(parameters) {
      parameters.forEach(p=>{
        const value = this.activeParameters[p.replace('@#','')] as IEidosMatrixValue ?? '';
        exp = exp.replace(p, value.toString());
      });
    }

    if (exp.includes(MatrixFormulaRangeType.All)) {
      exp = self.expandRangeRif(exp, cur, MatrixFormulaRangeType.All);
      rifCell = exp.split(rCellRif).filter(s => s.includes('@'));
    }
    if (exp.includes(MatrixFormulaRangeType.Before)) {
      exp = self.expandRangeRif(exp, cur, MatrixFormulaRangeType.Before);
      rifCell = exp.split(rCellRif).filter(s => s.includes('@'));
    }
    if (exp.includes(MatrixFormulaRangeType.After)) {
      exp = self.expandRangeRif(exp, cur, MatrixFormulaRangeType.After);
      rifCell = exp.split(rCellRif).filter(s => s.includes('@'));
    }

    //erase on skipCondition
    rifCell
      .filter(rif=>skipCondition && this.resolveFormula(skipCondition, self.evaluateRif(rif, cur)))
      .forEach(function (rif) {
        const lRif = rif.replace('@s_', '@s-')
          .replace('@r_', '@r-')
          .replace('@c_', '@c-');
        exp = exp.replace('+ '+lRif, '').replace(lRif, '');
      });



    rifCell
      .forEach(function (rif) {
        const values = (self.getMatrixCellValue(self.evaluateRif(rif, cur)) ?? '').toString();
        const lRif = rif.replace('@s_', '@s-')
          .replace('@r_', '@r-')
          .replace('@c_', '@c-');
        exp = exp.replace(lRif, values);
      });

    //Inject Global Object and function Helper and eval
    try {
      let gf:string = '';
      for(const k in this.activeFunction) {
        gf += 'function '+this.activeFunction[k].toString();
      }
      const fullExp = `${gf} var context = {cell:{sheet: ${cur.sheet},row: ${cur.row}, col: ${cur.column}}}; ${exp}`;
      const v =(0,eval)(fullExp);
      return v;
    } catch (e) {
      this.activeConfig.sheets[cur.sheet].columns[cur.column].evaluateExceptions(e as Error);
      return null;
    }
  }

  checkManualTouched(cur: IMatrixRif): boolean {
    const status = this.activeData[cur.sheet][cur.row][`__${cur.columnName}`] as IMatrixCellStatus;
    return status.isManualTouched;
  }
  setManualTouched(cur: IMatrixRif): void {
    (this.activeData[cur.sheet][cur.row][`__${cur.columnName}`] as IMatrixCellStatus).isManualTouched = true;
  }
  evaluateFormula(column: MatrixColumn, sheet: number, row: number): Set<IMatrixRif> {
    const touched: Set<IMatrixRif> = new Set();
    if (!column.hasFormula()) return touched;

    const cur = { sheet: sheet, row: row, column: column.position, columnName: column.name } as IMatrixRif;
    if (this.checkManualTouched(cur)) return touched;

    let flist = column.formulas.filter(c => c.condition && c.condition.trim() !== '' && this.resolveFormula(c.condition, cur) === true);
    if (flist.length === 0) flist = column.formulas.filter(c => c.condition === undefined || c.condition.trim() === '');
    if (flist.length > 0) {
      const newValue = this.resolveFormula(flist[0].formula, cur,flist[0].skipCondition);
      const oldValue = this.activeData[column.sheet][row][column.name];
      this.activeData[column.sheet][row][column.name] = newValue;
      if (newValue != oldValue) column.dependencies.forEach(d => { if (d.sheet === sheet && d.row === row) touched.add(d); });
    }
    return touched;
  }
  evaluateFormulaRif(column: MatrixColumn, sheet: number, row: number) {
    const cur = { sheet: sheet, row: row, column: column.position, columnName: column.name } as IMatrixRif;
    column.formulas.forEach(f => {
      this.getFormulaRif(f.formula, cur).forEach(r => {
        this.activeConfig.sheets[r.sheet].columns[r.column].dependencies.add(cur);
      });
      if(this.hasParametersRif(f.formula)) this.parametersDependencies.add(cur);
    });
  }
  hasParametersRif(formula: string) {
    return (formula.match(rParamRif)?.length ?? 0 ) > 0;
  }
  getFormulaRif(formula: string, cur: IMatrixRif): Array<IMatrixRif> {
    const dep: Array<IMatrixRif> = [];
    const self = this;

    let rifCell = formula.replace(/@s-/g, '@s_')
      .replace(/@r-/g, '@r_')
      .replace(/@c-/g, '@c_')
      .split(rCellRif)
      .filter(s => s.includes('@'));

    let exp = formula;

    if (exp.includes(MatrixFormulaRangeType.All)) {
      exp = this.expandRangeRif(exp, cur, MatrixFormulaRangeType.All);
      rifCell = exp.split(rCellRif).filter(s => s.length > 0);
    }
    if (exp.includes(MatrixFormulaRangeType.Before)) {
      exp = this.expandRangeRif(exp, cur, MatrixFormulaRangeType.Before);
      rifCell = exp.split(rCellRif).filter(s => s.length > 0);
    }
    if (exp.includes(MatrixFormulaRangeType.After)) {
      exp = this.expandRangeRif(exp, cur, MatrixFormulaRangeType.After);
      rifCell = exp.split(rCellRif).filter(s => s.length > 0);
    }

    rifCell.forEach(function (rif) {
      dep.push(self.evaluateRif(rif, cur));
    });

    return dep;
  }

  onTabDragStart(e: any) {
    e.itemData = e.fromData[e.position];
  }

  onTabDrop(e: any) {
    e.fromData.splice(e.position, 1);
    e.toData.splice(e.toIndex, 0, e.itemData);
  }
  addRow(sheet: EidosMatrixSheet): void {
    this.requestNewRow.emit({ api: this.api, sheet: sheet });
  }
  addColumn(sheet: EidosMatrixSheet): void {
    this.requestNewColumn.emit({ api: this.api, sheet: sheet });
  }
  execAction(action: string, sheet: EidosMatrixSheet): void {
    this.requestExecAction.emit({ action: action, api: this.api, sheet: sheet });
  }
  triggerAction(action: string, callback:(resquestAction:IEidosMatrixRequestAction)=>void, sheetIndex?: number): void {
    if(sheetIndex===undefined) sheetIndex = this.activeSheet;
    const sheet = sheetIndex >= 0 && sheetIndex< this.activeConfig.sheets.length ? this.activeConfig.sheets[sheetIndex] : null;
    if(sheet===null) return;

    callback({ action: action, api: this.api, sheet: sheet });
  }

  applyFormulaParametersChange(){
    for (let key in this.activeOnChangeParameters) {
      const value = this.activeParameters[key] as IEidosMatrixValue ?? '';
      this.activeOnChangeParameters[key](value,this.activeData,this.api);
    }
  }
  initializeComponent() {
    this.config.subscribe(c => {
      this.initilized = false;
      if(c.formulaParameters) {
        //catch formula parameters changes and recompute cell whit dependences
        c.formulaParameters.subscribe({
          next:(fp)=>{
            this.activeParameters = fp;
            this.parametersDependencies.forEach(d=>this.evaluateFormula(this.activeConfig.sheets[d.sheet].columns[d.column], d.sheet, d.row));
            this.applyFormulaParametersChange();
          }
        });
      }
      if(c.onChangeParametersFun) this.activeOnChangeParameters = c.onChangeParametersFun;
      if(c.formulaFunctions) this.activeFunction = c.formulaFunctions;


      c.triggerAction = this.triggerAction.bind(this)
      //this.activeConfig = new MatrixConfig(MatrixConfig.EmptyConfig);
      if (this._test) {
        this.activeConfig = new EidosMatrixConfig(EidosMatrixConfig.TestConfig);
        this.activeData = this.activeConfig.initialize([]);
      } else {
        this.activeConfig = new EidosMatrixConfig(c);
        this.activeData = this.activeConfig.initialize(this.matrixData);
      }
      this.api.activeConfig = this.activeConfig;
      this.api.activeData = this.activeData;
      this.applyFormulaParametersChange();
      this.activeConfig.callback.onAfterDataInitialize(this.api);

      this.evaluateDependecies();
      this.evaluateCells();

      if (this.matrixSheetComponents) this.matrixSheetComponents.forEach(g => g.instance.refresh());
      this.initilized = true;
      this.activeConfig.callback.onAfterInitialize(this.api);
    });
  }
  resetDependencies() {
    this.activeConfig.sheets.forEach(sheet => {
      sheet.columns.forEach(column => {
        column.dependencies.clear();
      });
    });
    this.parametersDependencies.clear();
  }
  evaluateDependecies() {
    this.activeConfig.sheets.forEach(sheet => {
      sheet.columns.forEach(column => {
        if (column.hasFormula()) {
          for (let row = 0; row < sheet.rows; row++) {
            this.evaluateFormulaRif(column, sheet.position, row);
          }
        }
      });
    });
  }
  columnOptionValue(sheet: number, colname: string | number, option: string, value: any): void {
    if (!this.matrixSheetComponents) return;
    const g = this.matrixSheetComponents.filter((_, idx) => idx === sheet);
    if (g.length > 0) {
      const gridInstance = g[0].instance;
      gridInstance.columnOption(colname, option, value);
    }
  }
  getInstance(sheet: number): dxDataGrid | null {
    if (!this.matrixSheetComponents) return null;
    const g = this.matrixSheetComponents.filter((_, idx) => idx === sheet);
    if (g.length > 0) return g[0].instance;
    return null;
  }
  ngOnInit(): void {
    this.initializeComponent();
  }
  ngAfterViewInit(): void {
    if (this.matrixSheetComponents) {
      this.matrixSheetComponents.forEach(
        (ms, idx) => {
          this.activeConfig.sheets.filter(s => s.position === idx).map(
            s => {
              s.gridComponent = ms;
            })
        });

      this.matrixSheetComponents.changes.subscribe(
        {
          next: (ql: QueryList<DxDataGridComponent>) => {
            ql.forEach(dg => dg.instance.refresh());
            //this.matrixSheets.forEach(g=>g.refresh());
          }
        });
    }
  }

}

